interface DashedFlightPathSvgProps {
	className?: string;
}

/** Decorative dashed flight path with a paper-plane accent. */
function DashedFlightPathSvg(prop: DashedFlightPathSvgProps) {
	const { className } = prop;
	return (
		<svg viewBox="0 0 90 60" className={className} aria-hidden>
			<path
				d="M4 40c14 14 30 16 40 4s10-28 30-30"
				fill="none"
				stroke="currentColor"
				strokeWidth="1.6"
				strokeDasharray="1 6"
				strokeLinecap="round"
			/>
			<circle
				cx="30"
				cy="14"
				r="9"
				fill="none"
				stroke="currentColor"
				strokeWidth="1.4"
				strokeDasharray="1 5"
			/>
			<g transform="translate(66 6) rotate(35)">
				<path
					d="M0 8 18 0 8 18 6 11Z"
					fill="white"
					stroke="white"
					strokeWidth="1"
					strokeLinejoin="round"
				/>
			</g>
		</svg>
	);
}

export default DashedFlightPathSvg;
